var map = {
	"./__tests__/handleLtiPostMessages.test.js": [
		"Af1U",
		716
	],
	"./__tests__/lti.resourceImported.test.js": [
		"yySz",
		655
	],
	"./__tests__/requestFullWindowLaunch.test.js": [
		"w8Zi",
		656
	],
	"./handleLtiPostMessage.js": [
		"y+46"
	],
	"./lti.resourceImported.js": [
		"75OS",
		717
	],
	"./messageTypes.js": [
		"0YqI"
	],
	"./requestFullWindowLaunch.js": [
		"S3m7",
		718
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9cv0";
module.exports = webpackAsyncContext;